import { memo, PropsWithChildren, useCallback, useContext } from 'react';
import { Link, To } from 'react-router-dom';
import { Button } from 'src/common/Button/Button';
import { ArrowLeftIcon } from 'src/modules/common/icons/ArrowLeftIcon';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { ConfigContext } from 'src/configContext.ts';

type Props = PropsWithChildren<{
    to: To;
    state?: Record<string, unknown>;
    type: 'forward' | 'back';
    disabled?: boolean;
    eventData?: Record<string, unknown>;
    isMobile?: boolean;
}>

export const NavigationButton = memo(({
    to,
    state,
    type,
    disabled,
    eventData,
    isMobile = false,
    children,
}: Props) => {
    const { gaPush } = useContext(ConfigContext);
    const onClick = useCallback(() => {
        if (eventData && disabled !== true) {
            gaPush(eventData);
        }
    }, [eventData, gaPush, disabled]);
    return (
        <Button
            onClick={onClick}
            as={Link}
            to={to}
            state={state}
            kind={type === 'back' ? 'ghost-secondary' : 'primary'}
            size={isMobile ? 'md' : 'sm'}
            reversed={type === 'back'}
            disabled={disabled}
            fullWidth={isMobile}
            icon={(
                <div className="vss-navigation__button-icon">
                    {type === 'back' ? (<ArrowLeftIcon/>) : (<ArrowRightIcon/>)}
                </div>
            )}
        >
            {children}
        </Button>
    );
});
